import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../../util/assets';
import AlbumFolderStartShutterbugHeadMeta from './AlbumFolderStartShutterbugHeadMeta';
import ContextualString from '../../../../../../../components/contextual/ContextualString';
import Button from '../../../../../../../components/global/Button';
import OnboardingLayoutContentNarrow from '../../../OnboardingLayout/components/OnboardingLayoutContentNarrow';
import {
  getAccountCheckoutGreetingName,
  getAccountUsername,
} from '../../../../../../../util/account';
import getConfig from '../../../../../../../util/config';
import LogoPoweredBy from '../../../../../../../components/global/LogoPoweredBy';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onGetStarted: PropTypes.func,
};

const AlbumFolderStartShutterbug = ({ albumFolder, onGetStarted }) => {
  const displayName = getAccountCheckoutGreetingName(albumFolder.account);
  const username = getAccountUsername(albumFolder.account);
  const config = getConfig();
  const displayNameComponent = (() => {
    if (username) {
      return (
        <a href={`/@${username}`} className="text-sm mb-2">
          By {displayName}
        </a>
      );
    }
    return <p className="text-sm">By {displayName}</p>;
  })();

  return (
    <Fragment>
      <OnboardingLayoutContentNarrow>
        <AlbumFolderStartShutterbugHeadMeta />
        <h4 className="mb-1 text-center">Welcome to</h4>
        <h2 className="text-black mb-1 text-center">{albumFolder.name}!</h2>

        {displayName && displayNameComponent}

        <p className="text-center mb-0">
          <ContextualString
            id="proLandingPageFeaturedText"
            type={albumFolder.album_type}
            subtype={albumFolder.album_subtype}
            defaultMessage="Powered by AI, Waldo sends you every photo you appear in."
            values={{
              profileDisplayName:
                albumFolder.account?.organization_name ??
                albumFolder.account?.name,
            }}
          />{' '}
          Upload a selfie and Waldo will find all your photos for you!
        </p>
        <img
          src={getAsset('/waldo-way.png')}
          height="140px"
          className="my-2"
          alt="Waldo Way"
        />
        <Button onClick={onGetStarted} className="mt-2" btnBlock>
          Let&apos;s Get Started!
        </Button>

        <div className="d-flex mt-1">
          <a href="/terms" target="_blank" className="m-auto text-xs">
            Terms of Use
          </a>
        </div>
      </OnboardingLayoutContentNarrow>
      <a
        href={config.marcomUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="discovery-start-logo"
      >
        <LogoPoweredBy />
      </a>
    </Fragment>
  );
};

AlbumFolderStartShutterbug.propTypes = propTypes;

export default AlbumFolderStartShutterbug;
